import { render } from "./UserResetPassword.vue?vue&type=template&id=2eef72be&scoped=true"
import script from "./UserResetPassword.vue?vue&type=script&lang=js"
export * from "./UserResetPassword.vue?vue&type=script&lang=js"

import "./UserResetPassword.vue?vue&type=style&index=0&id=2eef72be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eef72be"]])

export default __exports__